import { graphql, useStaticQuery } from "gatsby"

import { QueryFragments } from "./queryFragments"

export const useSiteConfig = () => {
  const { sanitySiteConfig } = useStaticQuery(graphql`
    query {
      sanitySiteConfig {
        mainNav {
          ... on SanityPageLink {
            _type
            ...PageLinkFields
          }
          ... on SanityPathLink {
            _type
            ...PathLinkFields
          }
        }
        socialLinks {
          link
          icon
        }
        footerNav {
          ... on SanityPageLink {
            _type
            ...PageLinkFields
          }
          ... on SanityPathLink {
            _type
            ...PathLinkFields
          }
        }
      }
    }
  `)
  return sanitySiteConfig || {}
}
